import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Presence from "./sections/Presence";
import HeroEvaluation from "./sections/HeroEvaluation";
import Offerings from "./sections/Offerings";
import ImpactStatistics from "./sections/ImpactStatistics";
import Consultant from "./sections/Consultant";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
import AboutTeaser from "./sections/AboutTeaser";
export default function HomePage() {
  return <div>
      <Navigation />
      <Presence />
      <HeroEvaluation />
      <Consultant />
      <Offerings />
      <ImpactStatistics />
      <AboutTeaser />
      <Contact />
      <Footer />
    </div>;
}